import { render, staticRenderFns } from "./LancarNota2T.vue?vue&type=template&id=4bbfe2e8&"
import script from "./LancarNota2T.vue?vue&type=script&lang=js&"
export * from "./LancarNota2T.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports